/* @license @google-recaptcha/core v1.0.5 */
import{generateGoogleReCaptchaHiddenBadgeStyles as e}from"./generateGoogleReCaptchaHiddenBadgeStyles.js";var t=function(){var t=document.createElement("style");t.innerHTML=e(),document.body.appendChild(t)};export{t as hideGoogleReCaptchaBadge};
//# sourceMappingURL=hideGoogleReCaptchaBadge.js.map
